import {createSlice, PayloadAction} from "@reduxjs/toolkit";

import {ITinderMultiLeadOpenPayload, ITinderMultiLeadSentItem, ITinderMultiLeadState} from "../types/tinder_multi_lead/ITinderMultiLeadState";
import {ApplicationSourceSection} from "../utils/form/application_form_source";

export const tinderMultiLeadInitialState: ITinderMultiLeadState = {
    isOpen: false,
    originPropertyId: 0,
    originOfferId: 0,
    originVendorId: 0,
    refererApplicationUuid: null,
    sourceSection: ApplicationSourceSection.MULTILEAD,
    customSourceSection: undefined,
    currentIndex: 0,
    rejectedPropertyIds: [],
    sentApplications: [],
    step: "browse",
    submittingPropertyId: null,
    error: null
};

export const tinderMultiLeadSlice = createSlice({
    name: "tinderMultiLead",
    initialState: tinderMultiLeadInitialState,
    reducers: {
        openTinderMultiLeadModal: (_state, action: PayloadAction<ITinderMultiLeadOpenPayload>) => ({
            ...tinderMultiLeadInitialState,
            ...action.payload,
            isOpen: true
        }),
        closeTinderMultiLeadModal: () => tinderMultiLeadInitialState,
        rejectCurrentTinderMultiLeadProperty: (state, action: PayloadAction<number>) => {
            if (!state.rejectedPropertyIds.includes(action.payload)) {
                state.rejectedPropertyIds.push(action.payload);
            }

            state.currentIndex += 1;
            state.error = null;
        },
        appendSentTinderMultiLeadApplication: (state, action: PayloadAction<ITinderMultiLeadSentItem>) => {
            state.sentApplications.push(action.payload);
            state.currentIndex += 1;
            state.submittingPropertyId = null;
            state.error = null;
        },
        showTinderMultiLeadSummary: (state) => {
            state.step = "summary";
            state.submittingPropertyId = null;
            state.error = null;
        },
        setTinderMultiLeadSubmittingProperty: (state, action: PayloadAction<number | null>) => {
            state.submittingPropertyId = action.payload;
        },
        setTinderMultiLeadError: (state, action: PayloadAction<string | null>) => {
            state.error = action.payload;
            state.submittingPropertyId = null;
        }
    }
});

export const {
    openTinderMultiLeadModal,
    closeTinderMultiLeadModal,
    rejectCurrentTinderMultiLeadProperty,
    appendSentTinderMultiLeadApplication,
    showTinderMultiLeadSummary,
    setTinderMultiLeadSubmittingProperty,
    setTinderMultiLeadError
} = tinderMultiLeadSlice.actions;
import {createSlice, PayloadAction} from "@reduxjs/toolkit";

import {ITinderMultiLeadOpenPayload, ITinderMultiLeadSentItem, ITinderMultiLeadState} from "../types/tinder_multi_lead/ITinderMultiLeadState";
import {ApplicationSourceSection} from "../utils/form/application_form_source";

export const tinderMultiLeadInitialState: ITinderMultiLeadState = {
    isOpen: false,
    originPropertyId: 0,
    originOfferId: 0,
    originVendorId: 0,
    refererApplicationUuid: null,
    sourceSection: ApplicationSourceSection.MULTILEAD,
    customSourceSection: undefined,
    currentIndex: 0,
    rejectedPropertyIds: [],
    sentApplications: [],
    step: "browse",
    submittingPropertyId: null,
    error: null
};

export const tinderMultiLeadSlice = createSlice({
    name: "tinderMultiLead",
    initialState: tinderMultiLeadInitialState,
    reducers: {
        openTinderMultiLeadModal: (_state, action: PayloadAction<ITinderMultiLeadOpenPayload>) => ({
            ...tinderMultiLeadInitialState,
            ...action.payload,
            isOpen: true
        }),
        closeTinderMultiLeadModal: () => tinderMultiLeadInitialState,
        rejectCurrentTinderMultiLeadProperty: (state, action: PayloadAction<number>) => {
            if (!state.rejectedPropertyIds.includes(action.payload)) {
                state.rejectedPropertyIds.push(action.payload);
            }

            state.currentIndex += 1;
            state.error = null;
        },
        appendSentTinderMultiLeadApplication: (state, action: PayloadAction<ITinderMultiLeadSentItem>) => {
            state.sentApplications.push(action.payload);
            state.currentIndex += 1;
            state.submittingPropertyId = null;
            state.error = null;
        },
        showTinderMultiLeadSummary: (state) => {
            state.step = "summary";
            state.submittingPropertyId = null;
            state.error = null;
        },
        setTinderMultiLeadSubmittingProperty: (state, action: PayloadAction<number | null>) => {
            state.submittingPropertyId = action.payload;
        },
        setTinderMultiLeadError: (state, action: PayloadAction<string | null>) => {
            state.error = action.payload;
            state.submittingPropertyId = null;
        }
    }
});

export const {
    openTinderMultiLeadModal,
    closeTinderMultiLeadModal,
    rejectCurrentTinderMultiLeadProperty,
    appendSentTinderMultiLeadApplication,
    showTinderMultiLeadSummary,
    setTinderMultiLeadSubmittingProperty,
    setTinderMultiLeadError
} = tinderMultiLeadSlice.actions;
